<template>
  <div class="pa-4">
    <v-row class="mb-4 align-center">
      <v-col cols="auto">
        <Breadcrump :crumbs="crumbs" />
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn @click="$router.go(-1)" fab small dark color="indigo">
          <v-icon dark>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        <span class="text-h5 IranSans">{{
          deviceId ? "تنظیمات مارکتینگ دستگاه" : "دستگاه جدید"
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  :disabled="device.freeSms"
                  outlined
                  type="number"
                  clearable
                  v-model="device.smsCredit"
                  label="اعتبار پیامک"
                  placeholder=" "
                  autocomplete="false"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  outlined
                  type="number"
                  v-model="device.multiplier"
                  label="ضریب گزارش"
                  placeholder=" "
                  autocomplete="false"
                  :rules="numRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  outlined
                  type="number"
                  v-model="device.impressionMultiplier"
                  label="ضریب استفاده (a)"
                  placeholder=" "
                  autocomplete="false"
                  :rules="numRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  outlined
                  type="number"
                  v-model="device.bias"
                  label="مقدار پیش‌فرض ایمپرشن (b)"
                  placeholder=" "
                  autocomplete="false"
                  :rules="biasRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  outlined
                  type="number"
                  v-model="device.delta"
                  label="دلتا (درصد)"
                  placeholder=" "
                  autocomplete="false"
                  :rules="deltaRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  outlined
                  type="number"
                  v-model="device.videoEffectPercentage"
                  label="درصد تاثیر ویدیو"
                  placeholder=" "
                  autocomplete="false"
                  :rules="deltaRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  outlined
                  type="number"
                  v-model="device.videoPerSeconds"
                  label="مدت زمان ویدیو (ثانیه)"
                  placeholder=" "
                  autocomplete="false"
                  :rules="biasRules"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="device.sendSmsStatus"
                  :label="
                    `ارسال پیامک: ${device.sendSmsStatus ? 'فعال' : 'غیر فعال'}`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="device.sendWinGameSmsStatus"
                  :label="
                    `ارسال پیامک برد بازی: ${
                      device.sendWinGameSmsStatus ? 'فعال' : 'غیر فعال'
                    }`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="device.sendLoseGameSmsStatus"
                  :label="
                    `ارسال پیامک باخت بازی: ${
                      device.sendLoseGameSmsStatus ? 'فعال' : 'غیر فعال'
                    }`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="device.powerBoxSign"
                  :label="
                    `امضای پاورباکس: ${
                      device.powerBoxSign ? 'فعال' : 'غیر فعال'
                    }`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="device.isBranded"
                  :label="`برند: ${device.isBranded ? 'دارد' : 'نامشخص'}`"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="device.freeSms"
                  :label="
                    `پیامک رایگان: ${device.freeSms ? 'فعال' : 'غیر فعال'}`
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-switch
                  v-model="device.signShow"
                  :label="
                    `نمایش امضا: ${device.signShow ? 'فعال' : 'غیر فعال'}`
                  "
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="#1976d2"
          class="white--text"
          @click="submit()"
          >ذخیره</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import request from "@/utils/request";
import Breadcrump from "@/components/common/Breadcrump.vue";

export default Vue.extend({
  name: "DeviceMarketing",
  components: {
    Breadcrump
  },
  data() {
    return {
      valid: false,
      deviceId: null,
      crumbs: [
        { text: "خانه", disabled: false, href: "/" },
        { text: "مجموعه ها", disabled: false, href: "/complexes" },
        {
          text: `مجموعه ${this.$store.state.selectedComplexName || ""}`,
          disabled: false,
          href: `/complex-units/${this.$store.state.selectedComplexId}`
        },
        {
          text: this.$store.state.selectedDeviceName || "دستگاه",
          href: `/complex-devices/${this.$store.state.selectedComplexId}`,
          disabled: false
        },
        { text: "گزارش مارکتینگ دستگاه", disabled: true }
      ],
      loading: false,
      device: {
        delta: 0,
        complexId: 0,
        multiplier: 1,
        videoEffectPercentage: 0,
        videoPerSeconds: 0,
        impressionMultiplier: 1,
        bias: 0,
        sendSmsStatus: false,
        sendWinGameSmsStatus: false,
        sendLoseGameSmsStatus: false,
        isBranded: false,
        freeSms: false,
        signShow: false,
        powerBoxSign: false,
        smsCredit: ""
      },

      deltaRules: [
        v => !!v || "لطفا مقدار را وارد نمایید",
        v => (v >= 0 && v <= 100) || "مقدار باید بین 0 تا 100 درصد باشد"
      ],
      nameRules: [v => !!v || "لطفا نام را وارد نمایید"],
      lockerCountRules: [v => !!v || "لطفا تعداد را وارد نمایید"],
      advertisingCodeRules: [v => !!v || "لطفا کد تبلیغات را وارد نمایید"],
      hardwareCodeRules: [v => !!v || "لطفا نام سخت افزاری را وارد نمایید"],
      phoneRules: [
        v => !v || /^09[0-9]{9}$/.test(v) || "شماره موبایل نامعتبر است"
      ],
      urlRules: [
        v =>
          !v ||
          /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(
            v
          ) ||
          "آدرس URL معتبر نیست"
      ],
      biasRules: [
        v => (v !== null && v !== undefined) || "لطفا مقدار را وارد نمایید",
        v => !isNaN(parseFloat(v)) || "مقدار وارد شده عدد نیست",
        v => Number.isInteger(Number(v)) || "مقدار باید عدد صحیح باشد",
        v => v >= 0 || "مقدار نمی‌تواند منفی باشد"
      ],
      numRules: [
        v => (v !== null && v !== undefined) || "لطفا مقدار را وارد نمایید",
        v => !isNaN(parseFloat(v)) || "مقدار وارد شده عدد نیست",
        v => v >= 0 || "مقدار نمی‌تواند منفی باشد"
      ]
    };
  },

  computed: {
    hasActiveGame() {
      return this.deviceConfiguration.games.some(g => g.isActive === true);
    }
  },

  created() {
    this.deviceId = this.$route.params.id;
    if (this.deviceId) this.getDevice(this.deviceId);
  },

  methods: {
    async getDevice(id) {
      const response = await request.get(`/device/${id}`);
      const data = response.data.result;

      this.device = {
        ...this.device,
        delta: data.delta,
        complexId: data.complexId,
        multiplier: data.multiplier,
        videoEffectPercentage: data.videoEffectPercentage,
        videoPerSeconds: data.videoPerSeconds,
        impressionMultiplier: data.impressionMultiplier,
        bias: data.bias,
        sendSmsStatus: data.sendSmsStatus,
        sendWinGameSmsStatus: data.sendWinGameSmsStatus,
        sendLoseGameSmsStatus: data.sendLoseGameSmsStatus,
        isBranded: data.isBranded,
        freeSms: data.freeSms,
        signShow: data.signShow,
        powerBoxSign: data.powerBoxSign,
        smsCredit: data.smsCredit
      };
    },

    resetForm() {
      this.device = {
        delta: 0,
        complexId: 0,
        multiplier: 1,
        videoEffectPercentage: 0,
        videoPerSeconds: 0,
        impressionMultiplier: 1,
        bias: 0,
        sendSmsStatus: false,
        sendWinGameSmsStatus: false,
        sendLoseGameSmsStatus: false,
        isBranded: false,
        freeSms: false,
        signShow: false,
        powerBoxSign: false,
        smsCredit: ""
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      const submitData = {
        ...this.device
      };

      if (this.deviceId) {
        request
          .put(`/device/${this.deviceId}/marketing`, submitData)
          .then(() => {
            Vue.swal("", "تغییرات با موفقیت اعمال شد", "success");
          });
        this.loading = false;
        setTimeout(() => {
          this.$router.push(`/complex-devices/${this.device.complexId}`);
        }, 2500);
      }
    }
  }
});
</script>

<style scoped>
.pa-4 {
  padding: 20px;
}

.IranSans {
  font-family: "IranSans", sans-serif !important;
}
</style>
